import type { ProductItemProps } from './components/ProductItem'
import ProductItemImage from './components/ProductItemImage'
import CartListItemVariantWeight from './components/ProductVariantWeight'
import { currency } from '~/lib/currency'

const ProductItemDetails = ({ item, isControled }: ProductItemProps) => {
  // TODO: get href from item. To be implemented in the future
  const variableWeight = item.measurementUnit === 'kg'
  const formatPrice = (price: number | null) => {
    return price === null ? 'Indisponível' : currency(price)
  }

  return (
    <>
      <ProductItemImage alt={item.name} className="w-[48px] min-w-[48px]" src={item.imageUrl} />
      <div className="grow">
        <p className="leading-4 pb-2">{item.name}</p>
        <div className="flex justify-between items-start">
          <span className="leading-5">
            <span className="text-xxs text-gray-40 block tracking-wide">
              {variableWeight ? 'Preço:' : 'Preço/Emb:'}
            </span>
            <span className="pl">{formatPrice(item.price)}</span>
            {variableWeight && <CartListItemVariantWeight />}
          </span>
          {!isControled && (
            <span className="text-xs px-1.5 py-1 rounded bg-gray-20">Qtd: {item.quantity}</span>
          )}
        </div>
      </div>
    </>
  )
}

export default ProductItemDetails
